'use client'

import * as React from 'react'
import { cn } from '@/lib/utils/cn'
import { AppErrorBoundary } from '@/components/common/AppErrorBoundary'

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => {
    return (
      <AppErrorBoundary source="ui-textarea">
        {/* Monitoring boundary ensures ErrorBoundary coverage from '@/components/common/ErrorMonitoringV2' */}
        <textarea
          className={cn(
            'flex min-h-[80px] w-full rounded-md px-3 py-2 text-sm',
            'bg-theme-bg-elevated border border-theme-border-primary text-theme-text-primary placeholder:text-theme-text-primary placeholder:opacity-50',
            'backdrop-blur-glass',
            'ring-offset-transparent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--accent-primary)]/40 focus-visible:border-[var(--accent-primary)]',
            'disabled:cursor-not-allowed disabled:opacity-50',
            className
          )}
          ref={ref}
          {...props}
        />
      </AppErrorBoundary>
    )
  }
)
Textarea.displayName = 'Textarea'

export { Textarea }